module.exports = __webpack_public_path__ + "img/camel.2f122d75.png";